import React, { useState, useRef, Fragment } from "react";
import {
  Button,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  Typography,
  IconButton,
  Box,
  Alert,
  CircularProgress,
  InputAdornment,
  DialogTitle,
  useTheme,
} from "@mui/material";
import Draggable from "react-draggable";
import Icon from "@mdi/react";
import {
  mdiKey,
  mdiLockReset,
} from "@mdi/js";
import axios from "axios";
import $ from "jquery";
import { paperPropsSmallTall } from "../css/muiStyle";
import DynamicField from "../compo/form_fields";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "../compo/LanguageSwitcher";
function PaperComponent(props) {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel='[class*="MuiDialogContent-root"]'
    >
      <Paper ref={nodeRef} {...props} />
    </Draggable>
  );
}

export default function ForgotPwd(props) {
  const theme = useTheme();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [nom, setNom] = useState(props.email);
  const [error, setError] = useState(false);
  const [msg, setMsg] = useState(false);
  const [loading, setLoading] = useState(false);
  const param = props.param;
  const formRef = useRef(null);

  $(document).ready(function () {
    $("#tel-edit").on("input", function (ev) {
      var $this = $(this);
      var value = $this.val();
      if (value && value.length > 10) {
        $this.val(value.substr(0, 10));
      }
    });
  });

  const handleClickOpen = () => {
    setOpen(true);
    setMsg(false);
    setNom(props.email);
    setError(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const vidage = () => {
    setOpen(false);
    setNom("");
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (nom !== "") {
      setLoading(true);
      setError(false);
      await axios({
        method: "POST",
        url: param.urlService + "forgot.php",
        headers: {
          "content-type": "application/json",
          appID: param.appID,
        },
        data: JSON.stringify({ login: nom }),
      })
        .then((response) => {
          if (response.data.err) {
            alert(response.data.err);
            setOpen(false);
            setLoading(false);
          } else {
            setMsg(response.data.jData);
            setLoading(false);
            setTimeout(vidage, 5000);
          }
        })
        .catch((error) => {
          alert(error);
          setLoading(false);
        });
    } else {
      setError(true);
    }
  };

  const testPhone = (e) => {
    const re = /^[0-9\b]+$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      setNom(e.target.value);
    }
  };

  return (
    <Fragment>
      {/* transfer the styling to pw-login */}
      <Box
        onClick={handleClickOpen}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          cursor: "pointer",
          color: "text.secondary",
          "&:hover": {
            color: "primary.main",
          },
          transition: "color 0.2s",
          fontSize: "0.875rem",
          fontWeight: 500,
        }}
      >
        <Icon path={mdiKey} size={0.75} />
        <span>{t("login.forget_password")}</span>
      </Box>

      <Dialog
        open={open}
        id="changePass"
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        PaperProps={paperPropsSmallTall}
      >

        <DialogTitle id="draggable-dialog-title">
          {t("login.reset_password")}
        </DialogTitle>
        <DialogContent sx={{ padding: '10px 24px', }}>
          <form ref={formRef} id="userForm" onSubmit={handleSubmit}>
            <DynamicField
              fieldType="textfield"
              id="iNom"
              name="nom"
              type="email"
              label={t("common.email")}
              placeholder="vous@exemple.com"
              value={nom}
              onChange={(value) => {
                setNom(value);
                setError(false);
              }}
              error={error}
              helperText={error ? t("common.HelperEmailText") : ""}
              required
              autoFocus
            />
          </form>
          {msg === true && (
            <Alert
              severity="success"
              sx={{
                width: "100%",
                height: "30px",
                minHeight: "30px",
                padding: "0 12px 0 8px",
                margin: "4px 0 0 0",
                display: "flex",
                alignItems: "center",
                border: "1px solid",
                borderColor: "success.light",
                borderRadius: "4px",
                '& .MuiAlert-icon': {
                  padding: "0",
                  marginRight: "8px",
                  fontSize: "16px",
                },
                '& .MuiAlert-message': {
                  padding: "0",
                  fontSize: "0.8125rem",
                  lineHeight: "1.2",
                },
              }}
            >
              {t("login.successPasswordReset")}
            </Alert>

          )}
        </DialogContent>

        <DialogActions className='dialog-actions'>
          <Button
            variant="contained"
            type="submit"
            form="userForm"
            className="Button-submit"
            startIcon={<Icon path={mdiLockReset} color="white" size="18px" />}
          >
            {loading ? t("common.send") : t("common.reset")}
          </Button>
          <Button
            variant="outlined"
            onClick={handleClose}
            className="Button-close"
          >
            {t("common.close")}
          </Button>
        </DialogActions>
      </Dialog>

    </Fragment>
  );
}